import { CircleCheckIcon, OctagonXIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
    const { theme = 'light' } = useTheme();

    return (
        <Sonner
            theme={theme as ToasterProps['theme']}
            icons={{
                success: <CircleCheckIcon className="size-5 text-green-600" />,
                error: <OctagonXIcon className="size-5 text-red-600" />,
            }}
            {...props}
        />
    );
};

export { toast } from 'sonner';
export { Toaster };
